import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs/Subscription";
import {WithdrawalActions} from "../../../../store-management/redux/scans.actions";
import {environment} from "../../../../../environments/environment";
import {interval} from "rxjs/observable/interval";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {TouchMenuService} from "../touch-menu.service";
import {Observable} from "rxjs/Observable";
import {VbMenuEntry} from "../menu-item.interface";

@Component({
  selector: 'vb-touch-navigation-menu',
  templateUrl: './touch-navigation-menu.component.html',
  styleUrls: ['./touch-navigation-menu.component.css']
})
export class TouchNavigationMenuComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  wdCommitSub: Subscription;
  activeEntries$: Observable<VbMenuEntry[]>;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private route: ActivatedRoute, private wdActions: WithdrawalActions,
              private touchMenuService: TouchMenuService) {
    super(sessionActions, cd);
    this.activeEntries$ = this.touchMenuService.activeMenuEntries$;
  }

  ngOnInit() {
    super.ngOnInit();

    this.addSubscription(this.wdCommitSub = interval(environment.touch.commit_interval * 1000).subscribe(() => {
      this.wdActions.commitWithdrawals().subscribe();
    }));

  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/navigation/touch-navigation-menu/touch-navigation-menu.component.ts